<template>
  <CenteredBox>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-4">
          <h1 class="mb-4">Sign In</h1>

          <form
            @submit.prevent="onSubmit"
          >
            <FormInput
              v-model="email"
              type="email"
              id="email"
              label="Email address"
              :error="getFieldError('email')"
            />

            <FormInput
              v-model="password"
              type="password"
              id="password"
              label="Password"
              :error="getFieldError('password')"
            />

            <FormError
              :error="getRequestError()"
            />

            <FormButton
              :isProcessing="isProcessing"
            >
              Sign in
            </FormButton>
          </form>
        </div>
      </div>
    </div>
  </CenteredBox>
</template>

<script>
  import RequestMixin from '@/mixins/RequestMixin'

  import CenteredBox from '@/components/CenteredBox'
  import FormButton from '@/components/FormButton'
  import FormError from '@/components/FormError'
  import FormInput from '@/components/FormInput'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      CenteredBox,
      FormButton,
      FormError,
      FormInput,
    },

    data() {
      return {
        email: '',
        password: '',
      }
    },

    methods: {
      async signIn() {
        await this.$store.dispatch('signIn', {
          email: this.email,
          password: this.password,
        })

        if (this.$route.query.redirect)
          return this.$router.push({
            path: decodeURIComponent(this.$route.query.redirect),
          })

        return this.$router.push({
          name: 'admin',
        })
      },

      async onSubmit() {
        this.handleRequest(this.signIn)
      },
    },
  }
</script>

<style lang="scss">
  @import "@/styles/_admin.scss";
</style>

